import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigationType } from "react-router-dom";
import {AnimatePresence, motion } from "motion/react";
import "scroll-behavior-polyfill";
import ProjectSlider from "components/ProjectSlider";
import Footer from "components/Footer";
import Topbar from "components/Topbar";
import Focus from "components/Focus";

import arrow from "img/icons/arrow.svg";

const anims = {
  visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeInOut" } },
  hidden: { opacity: 0, y: 30, transition: { duration: 1, ease: "easeInOut" } }
}

const Main = (props) => {

  const navigationType = useNavigationType();
  const location = useLocation();

  const [mainPortfolio, setMainPortfolio] = useState(true);
  const [currentProject, setCurrentProject] = useState(null);

  const mainElem = useRef(null);
  const focusElem = useRef(null);
  const workArea = useRef(null);

  useEffect(() => {
    if (props.position === "work") {
      if (navigationType === "POP") {
        workArea.current.scrollIntoView();
      } else {
        workArea.current.scrollIntoView({ behavior: "smooth" });
      }
    }

    if (props.position === "focus" && navigationType === "POP") {
      setCurrentProject(location.pathname.substring(1));
    } else {
      setCurrentProject(null);
    }
  }, [props.position, navigationType, location]); // triggers on route change

  useEffect(() => {
    if (props.position === 'focus') document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [props.position]);

  return (
    <>
      {((props.position === "focus")) &&
        <Focus vH={props.vH} />
      }

      <Topbar
        state={(props.position === "work") ? "work" : null}
        mainElem={mainElem}
        focusElem={focusElem}
      />
      <main
        ref={mainElem}
        className={((props.position === "focus") ? ("disable") : "")}
        data-alt-view={!mainPortfolio}
      >
        <motion.section
          className="tile intro"
          initial="hidden"
          animate="visible"
          variants={anims}
        >
          <div className="shape-break">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="hero">
            <div className="hero-type">
              <div className="hero-text">
                <h1>User experience designer & developer, with a specific interest in musical applications.</h1>
              </div>
              <div className="hero-sub">
                <p>Explore a collection of my work.</p>
                <Link to="/work">
                  <button className="icon round">
                    <img
                      className="arrow"
                      src={arrow}
                      alt="down arrow"
                    />
                  </button>
                </Link>
              </div>
            </div>
            {/* <img className="hero-img" src={testArt}></img> */}
          </div>
        </motion.section>

        <section ref={workArea} className="tile projects">

          <ProjectSlider
            key={'slider'}
            vW={props.vW}
            vH={props.vH}
            workRef={workArea}
            mainPortfolio={mainPortfolio}
            setMainPortfolio={setMainPortfolio}
            currentProject={currentProject}
          />

        </section>
        <Footer />
      </main>
    </>
  )
}

export default Main;